module.exports = __webpack_public_path__ + "71e460c034a025cb85beb76f99d29044.pdf";